import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { ActiveSupplierCountReport } from './Pages';

export const ActiveSupplierCountReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={ActiveSupplierCountReport} />
    </Fragment>
)